import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfiguration } from "../constants/msalConfig";

const msalInstance = new PublicClientApplication(msalConfiguration);

export default msalInstance;
